import type { ReactNode } from 'react';

export const PrintOnly: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="print-only">{children}</div>;
};
